export const cacheKey = "/apps/user_event_history/:user_identifier";
